module.exports = __webpack_public_path__ + "static/media/image03.252ec468.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/image03.jpg
// module id = 304
// module chunks = 0